import React from 'react';
import MainAppLayout from './components/MainAppLayout';

function App() {
  return (
    <MainAppLayout />
  );
}

export default App;